<div class="container" *ngIf="!isDetail">
    <div class="semi-header">
        <div class="row">
            <div class="col-4 col-lg-2" *ngFor="let filItem of visibleFiltros">
                <button class="btn btn-primary" [ngClass]="{'cat-selected': filItem.id == selectedFilter}" (click)="onSelectFilter(filItem)">{{filItem.name}}</button>
            </div>
        </div>
        <br>
        <form >
            <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-6">
                    <mat-form-field class="no-border" style="width: 100%;" appearance="outline">
                        <mat-label>Buscador general</mat-label>
                        <input class="no-border" matInput type="search" placeholder="Buscador general" (ngModelChange)="onTextChange($event)" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (keyup.enter)="filterByText()"/>
                        <mat-icon matSuffix class="search-icon" (click)="filterByText()">search</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 col-md-2 col-lg-2">
                    <div class="favorite-container">
                        <mat-icon (click)="onSelecFavorite()" [svgIcon]="iconFavorite" style="width: 2rem; height: 2rem;"></mat-icon>
                        <span class="favorite-span">Mis favoritos</span>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="home">
        <div class="cards-container" *ngIf="!isSublevel">
            <ng-container class="cat-container" *ngFor="let catItem of filterShowList; let i = index">
                <ng-container *ngIf="catItem.level">
                    <h3 class="title-section">{{(catItem.title).toUpperCase()}}</h3>
                    <br>
                    <div class="container-drag" (mouseenter)="showButtons(i)" (mouseleave)="hideButtons()">
                        <div class="floating-button left" [class.visible]="i == activeDrag" >
                            <mat-icon (click)="moveLeft(i)" class="arrow-cards">arrow_left</mat-icon>
                        </div>
                        <div class="floating-button right" [class.visible]="i == activeDrag" >
                            <mat-icon (click)="moveRight(i)" class="arrow-cards">arrow_right</mat-icon>
                        </div>
                        <drag-scroll #nav [scroll-x-wheel-enabled]="true" [scrollbar-hidden]="true" class="cards-box">
                            <div class="cards-card" drag-scroll-item="" *ngFor="let sublevel of catItem.sublevel; let i = index">
                                <div class="card shadow-sm" (click)="goToProduct(sublevel)">
                                    <div class="card-image" 
                                        [ngStyle]="{ 'background': 'url(&quot;' + sublevel.bannerURL + '&quot;) no-repeat center center', 'background-size': 'cover' }"
                                    >
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="icon-container" [ngClass]="{'no-display': sublevel.actions == null}">
                                        <div class="icon-actions" *ngIf="sublevel.actions != null">
                                            <mat-icon class="action-icon" (click)="updateFavoriteStatus(sublevel.id,!sublevel.isFavorite, catItem.title)" [svgIcon]="sublevel.isFavorite ? 'favorite_on' : 'favorite_off'">
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(1)" class="action-icon" (click)="actionToExecute(1,sublevel,catItem.title)" svgIcon="share" matTooltip="{{sublevel.sharedCount}}">
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(2)" class="action-icon" (click)="actionToExecute(2,sublevel, catItem.title)" svgIcon="whats">
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(3) && !sublevel.isDownloading" class="action-icon" (click)="actionToExecute(3,sublevel, catItem.title)" svgIcon="download"></mat-icon>
                                            <mat-spinner *ngIf="sublevel.isDownloading" diameter="25" color="warn"></mat-spinner>
                                        </div>                                        
                                        <div class="icon-type">
                                            <mat-icon style="cursor: default !important;" [svgIcon]="sublevel.type"></mat-icon>
                                        </div>
                                    </div>
                                    <span class="card-title">{{sublevel.title}}</span>
                                </div>
                            </div>
                        </drag-scroll>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        
        <div class="cards-container" *ngIf="isSublevel">
            <div class="row" style="align-items: center;">
                <mat-icon class="sublevel-back" matTooltip="Atras" (click)="backToCatalog(3)">arrow_left</mat-icon>
                <h3 class="title-section">{{(productSelectedData.title).toUpperCase()}}</h3>
            </div>
            <br>
            <div class="row">
                <div [ngClass]="isSublevelWithDescription ? 'col-lg-8 col-md-6 col-xs-12' : 'col-12'" class="double-panel-cards" >
                    <mat-grid-list [cols]="colsToShowInCategory" rowHeight="350px" class="sublevel-gridlist">
                        <mat-grid-tile *ngFor="let sublevel of productSublevelsData" [colspan]="1" [rowspan]="1">
                            <div class="cards-card">
                                <div class="card shadow-sm" (click)="goToProduct(sublevel)">
                                    <div class="card-image" 
                                    [ngStyle]="{ 'background': 'url(&quot;' + sublevel.bannerURL + '&quot;) no-repeat center center', 'background-size': 'cover' }"
                                    ></div>
                                </div>
                                <div class="card-body">
                                    <div class="icon-container" [ngClass]="{'no-display': sublevel.actions == null}">
                                        <div class="icon-actions" *ngIf="sublevel.actions != null">
                                            <mat-icon class="action-icon" (click)="updateFavoriteStatus(sublevel.id,!sublevel.isFavorite, productSelectedData.title)" [svgIcon]="sublevel.isFavorite ? 'favorite_on' : 'favorite_off'">                                        
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(1)" class="action-icon" (click)="actionToExecute(1,sublevel,productSelectedData.title)" svgIcon="share" matTooltip="{{sublevel.sharedCount}}">
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(2)" class="action-icon" (click)="actionToExecute(2,sublevel,productSelectedData.title)" svgIcon="whats">
                                            </mat-icon>
                                            <mat-icon *ngIf="sublevel.actions.includes(3) && !sublevel.isDownloading" class="action-icon" (click)="actionToExecute(3,sublevel,productSelectedData.title)" svgIcon="download"></mat-icon>
                                            <mat-spinner *ngIf="sublevel.isDownloading" diameter="25" color="warn"></mat-spinner>
                                        </div>
                                        <div class="icon-type">
                                            <mat-icon style="cursor: default !important;" [svgIcon]="sublevel.type"></mat-icon>
                                        </div>
                                    </div>
                                    <span class="card-title">{{sublevel.title}}</span>
                                </div>
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>
                </div>
                <div [ngClass]="isSublevelWithDescription ? 'col-lg-4 col-md-6 col-xs-12' : 'col-0'" class="double-panel-html">
                    <div *ngIf="productSelectedData.positionImage == '1'">
                        <img [src]="productSelectedData.referenceImage" style="width: 28vw;">
                    </div>
                    <div class="ql-container ql-snow" style="border-width: 0; height: auto !important;" *ngIf="isSublevelWithDescription">
                        <div class="ql-editor" [innerHTML]="htmlContent" style="max-height: min-content;">
                        </div>
                    </div>
                    <div *ngIf="productSelectedData.positionImage == '0'">
                        <img [src]="productSelectedData.referenceImage" style="width: 28vw;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="containerDetail" *ngIf="isDetail">
    <div class="container-detail">
        <div class="main-detail">
            <div class="title-detail row">
                <div class="col-2 title-icon-container">
                    <mat-icon class="title-icon" [svgIcon]="productSelectedData.type"></mat-icon>
                </div>
                <div class="col-10">
                    <h3 class="title">{{productSelectedData.title}}</h3>
                    <!-- <p>{{productSelectedData.range}}</p> -->
                </div>
            </div>
            
            <div class="main-img-container">
                <div class="card-detail-img" 
                    [ngStyle]="{ 'background': 'url(&quot;' + productSelectedData.bannerURL + '&quot;) no-repeat center center', 'background-size': 'cover' }"
                >
                </div>
                <div class="detail-actions" *ngIf="productSelectedData.actions != null">
                    <mat-icon class="action-icon" (click)="updateFavoriteStatus(productSelectedData.id,!productSelectedData.isFavorite, productSelectedData.title)" [svgIcon]="productSelectedData.isFavorite ? 'favorite_on' : 'favorite_off'">
                    </mat-icon>
                    <mat-icon *ngIf="productSelectedData.actions.includes(1)" class="action-icon" (click)="actionToExecute(1,productSelectedData, productSelectedData.title)" svgIcon="share" matTooltip="{{productSelectedData.sharedCount}}">                                        
                    </mat-icon>
                    <mat-icon *ngIf="productSelectedData.actions.includes(2)" class="action-icon" (click)="actionToExecute(2,productSelectedData, productSelectedData.title)" svgIcon="whats">                                        
                    </mat-icon>
                    <!-- <mat-icon *ngIf="productSelectedData.actions.includes(3)" class="action-icon" (click)="actionToExecute(3,productSelectedData)" svgIcon="download">
                    </mat-icon> -->
                    <mat-icon *ngIf="productSelectedData.actions.includes(3) && !productSelectedData.isDownloading" class="action-icon" (click)="actionToExecute(3,productSelectedData, productSelectedData.title)" svgIcon="download"></mat-icon>
                    <mat-spinner *ngIf="productSelectedData.isDownloading" diameter="25" color="warn"></mat-spinner>
                </div>
            </div>            
        </div>          
        <div class="data-detail">
            <div class="data-info">
                <h4 style="font-family: 'MainFontBold';">Descripción</h4>
                <p>{{productSelectedData.internalDescription}}</p>
                <h4 style="font-family: 'MainFontBold';" *ngIf="productSelectedData.whenToUse != null">¿Cuándo utilizar este recurso?</h4>                
                <p>{{productSelectedData.whenToUse}}</p>
                <h4 style="font-family: 'MainFontBold';" *ngIf="productSelectedData.suggestedText != null">Texto sugerido para compartir</h4>
                <p>{{productSelectedData.suggestedText}}</p>
            </div>
            <div class="data-router">
                <span (click)="backToCatalog(3)" style="cursor: pointer;">
                    Inicio
                    <span style="cursor: none;"> > </span>
                </span>
                <span *ngFor="let detailParent of detailRouteList; let i = index" (click)="goToProduct(detailParent)" style="cursor: pointer;">
                    {{detailParent.title}} 
                    <span *ngIf="i != detailRouteList.length - 1" style="cursor: none;"> > </span>
                </span>
            </div>
        </div>
    </div>
</div>